import React from "react";
import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero-section" role="banner" aria-label="Veratrac Safety">
      {/* Bandeau catégorie */}
      <div className="hero-ribbon">
        Bureau de contrôle agréé par l’État
      </div>

      {/* Overlay + contenu */}
      <div className="hero-overlay">
        <div className="hero-content">
          <h1 className="hero-title">

           Solutions d'Inspection, de Contrôle <br/>
            et d'Expertise
          </h1>
          <p className="hero-subtitle">
            VERATRAC SAFETY — Bureau de contrôle, inspection et sécurité industrielle
          </p>

          <div className="hero-cta">
            <a className="btn btn-primary" href="#a-propos">NOTRE SOCIÉTÉ</a>
            <a className="btn btn-outline" href="#contact">DEVIS RAPIDE ET GRATUIT</a>
          </div>
        </div>
      </div>

      {/* Vague bas de section */}
      <div className="hero-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg" className="wave-svg">
          <path
            d="M0,96L48,106.7C96,117,192,139,288,165.3C384,192,480,224,576,213.3C672,203,768,149,864,144C960,139,1056,181,1152,186.7C1248,192,1344,160,1392,144L1440,128V320H0Z"
          />
        </svg>
      </div>
    </section>
  );
}
